import { MoreVertical } from 'lucide-react';
import React from 'react';

interface OnlineSafetyProps {
  onOpenMenu: () => void;
}

export default function OnlineSafety({ onOpenMenu }: OnlineSafetyProps) {
  return (
    <div className="h-screen md:h-auto bg-[#F5F5F5] flex flex-col">
      <div className="bg-[#FFFFFF] px-4 pt-6 pb-4 flex items-start justify-between border-b border-[#E0E0E0]">
        <h1 className="text-[28px] font-[700] leading-[1.2] text-[#212121] m-0 flex-1 pr-4">
          Online Safety Information
        </h1>
        <button
          onClick={onOpenMenu}
          className="p-2 min-w-[44px] min-h-[44px] flex items-center justify-center bg-transparent border-0 cursor-pointer flex-shrink-0"
          aria-label="Open menu"
        >
          <MoreVertical className="w-6 h-6 text-brand-primary" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto bg-[#FFFFFF] px-4 py-6">
        <div className="max-w-[640px] mx-auto">
          <p className="text-[14px] font-[400] text-[#212121] leading-[1.6] mb-3"> First and foremost, ISentryx is here to present users with a safe and exceptional experience.
            Report all suspicious and offensive behavior to the site support team. If someone crosses the line, makes you uncomfortable, or any other similar action you have the ability to Block that account.
            We encourage users to report anyone that violates our terms.</p>
          <h2 className="text-[16px] font-[700] text-[#212121] mb-3">
            Dating safety tips
          </h2>
          <p className="text-[14px] font-[400] text-[#212121] leading-[1.6] mb-3">While you can’t control the actions of others, there are things you can do to help you stay safe during your ISentryx experience.</p>

          <section className="mb-8">
            <h2 className="text-[16px] font-[700] text-[#212121] mb-3">
              Online safety recommendations
            </h2>

            {/* <p className="text-[14px] font-[400] text-[#212121] leading-[1.6]">
              •	Never send money or share financial information. Never send money, especially over wire transfer, even if the person claims to be in an emergency.  Wiring money is like sending cash- it’s nearly impossible to reverse the transaction or trace where the money went.  Never share information that could be used to access your financial accounts.  If another user asks you for money, report it to us immediately.
              <br></br>
              •	For tips on avoiding romance scams, check out some advice from the us federal trade commission on the FTC website
              Hyperlink.
            </p> */}
            <p className="text-[14px] font-[400] text-[#212121] leading-[1.6]">
              • Never send money or share financial information.
              <br />
              • Never send money, especially over wire transfer, even if the person claims to be in an emergency. Wiring money is like sending cash — it’s nearly impossible to reverse the transaction or trace where the money went. Never share information that could be used to access your financial accounts. If another user asks you for money, report it to us immediately.
              <br />
              • For tips on avoiding romance scams, check out some advice from the US Federal Trade Commission on the{" "}
              <a
                href="https://www.ftc.gov/"
                target="_blank"
                rel="noopener noreferrer"
                className="text-blue-600 underline"
              >
                FTC website Hyperlink
              </a>.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-[16px] font-[700] text-[#212121] mb-3">
              Protect your personal information
            </h2>
            <p className="text-[14px] font-[400] text-[#212121] leading-[1.6]">
              Never share personal information, such as your social security number, home or work address, or
              details about your daily routine (e.g. that you go to a certain gym every Monday) with people you
              don't know. If you are a parent limit the information that you share about your children on your
              profile and in early communications. Avoid sharing details such as your children's names, where
              they go to school, or their age or gender.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-[16px] font-[700] text-[#212121] mb-3">
              Stay on the Platform
            </h2>
            <p className="text-[14px] font-[400] text-[#212121] leading-[1.6]">
              Keep conversations on the ISentryx platform while you’re getting to know someone.  Because exchanges on ISentryx are subject to our safe message filters users with bad often try to move the conversation to text.  Messaging apps, email, or phone right away.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-[16px] font-[700] text-[#212121] mb-3">
              Be wary of long distance and overseas relationships.
            </h2>
            <p className="text-[14px] font-[400] text-[#212121] leading-[1.6]">
              Watch out for scammers who claim to be from your country, but are stuck somewhere else,
              especially if they ask for financial help to return home. Be leary of anyone that will not meet in person.
              Use common sense if it doesn’t feel right.  Don’t move forward.
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-[16px] font-[700] text-[#212121] mb-3">
              Protect your account

            </h2>
            <p className="text-[14px] font-[400] text-[#212121] leading-[1.6]">
              Be sure to pick a strong password and always be careful when logging into your account from a public or shared computer.  ISentryx will never send you an email asking for your username and password information.  If you receive an email asking for account information, report it immediately.
            </p>
          </section>
          <section className="mb-8">
            <h2 className="text-[16px] font-[700] text-[#212121] mb-3">
              Meeting in Person</h2>
            <p className="text-[14px] font-[400] text-[#212121] leading-[1.6]">
              •	Don’t be in a rush.<br></br>
              •	Get to know the other person before agreeing to meet or chat off ISentryx. Don’t be afraid to ask questions to screen any red flags or personal deal breakers.  A phone or video call can be a useful screening tool before meeting. <br></br>
              •	Meet in public and stay in public.<br></br>
              •	Meet for the first few times in a populated, public place. Never at your home or your dates home, or any other private location.  If your date pressures you to go to a private location, end the date. <br></br>
              •	Tell others.  Friends and family, your plans. Tell a friend or family member about your plans, including when and where you’re going.  Have your cell phone always charged and with you. <br></br>
              •	Be in control of your transportation. Being in control of your transportation allows you to be able to leave when you want to.  Be aware of drugs or alcohol as they can impair your judgement and awareness.  <br></br>
              •	Don’t leave drinks and personal items unattended.  Know who your drinks come from and never leave that drink unattended. <br></br>
              •	If you feel uncomfortable leave.<br></br>
            </p>
          </section>

          <section className="mb-8">
            <h2 className="text-[16px] font-[700] text-[#212121] mb-3">
              LGBTQ</h2>
            <p className="text-[14px] font-[400] text-[#212121] leading-[1.6]">
              At ISentryx we believe in the importance of inclusivity of all gender identities and sexual orientations, but not every place you visit may feel the same, so be aware of your surroundings.  If you are traveling to a location, check out the laws and what type of protection, if any, are available to you based on your sexual orientation.
            </p>
          </section>
          <section className="mb-8">
            <h2 className="text-[16px] font-[700] text-[#212121] mb-3">
              Sexual Health and Consent</h2>
            <p className="text-[14px] font-[400] text-[#212121] leading-[1.6]">
              •	Protect yourself<br></br>
              •	Common sense goes a long way.  Condoms provide significant reduction for the risk of contracting a passing on STI’s like HIV but be aware of STIs like herpes or HPV that can be passed on through skin-to-skin contact.  The risk of contracting some STIs can be reduced through protection.  Ie. Vaccination and proper condom use.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
}
